// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__OHaiq","left":"InfoRow_left__1o4dd"};